import React from "react";
import { Grid, TextField, makeStyles } from "@material-ui/core";
import { FieldValidationError, ValidationHelper } from "../../../services/server/ServerResponses";

export interface RegistrationFormRequest {
    fullName: string;
    email: string;
    password: string;
}

interface RegistrationFormProps {
    errors: FieldValidationError[];
    setForm: (form:RegistrationFormRequest) => void;
    formRequest: RegistrationFormRequest;
}

export function RegistrationForm(props:RegistrationFormProps){
    const { errors, formRequest } = props
    const classes = useStyles();

    return (
        <Grid item xs={12}>
            <TextField
                error={ValidationHelper.isFieldInError(errors, 'FullName')}
                id="fullname"
                variant="outlined"
                fullWidth
                value={formRequest.fullName}
                placeholder={"Full Name"}
                onChange={(e) => props.setForm({...formRequest, fullName: e.target.value})}
                className={classes.normalInput}
                InputLabelProps={{
                    style: {
                        fontWeight: 300,
                        fontFamily: 'Roboto, Helvetica, sans-serif',
                        fontSize: '16px',
                    }
                }}
                helperText={ValidationHelper.isFieldInError(errors, 'FullName') && ValidationHelper.getFieldErrorSummary(errors, 'FullName') }
                />
            <TextField
                error={ValidationHelper.isFieldInError(errors, 'Email')}
                id="email"
                variant="outlined"
                fullWidth
                value={formRequest.email}
                placeholder={"Email Address"}
                onChange={(e) => props.setForm({...formRequest, email: e.target.value})}
                className={classes.normalInput}
                InputLabelProps={{
                    style: {
                        fontWeight: 300,
                        fontFamily: 'Roboto, Helvetica, sans-serif',
                        fontSize: '16px',
                    }
                }}
                helperText={ValidationHelper.isFieldInError(errors, 'Email') && ValidationHelper.getFieldErrorSummary(errors, 'Email') }
                />
            <TextField
                error={ValidationHelper.isFieldInError(errors, 'Password')}
                id="password"
                variant="outlined"
                fullWidth
                type="password"
                value={formRequest.password}
                placeholder={"Create Password (6-12 Characters)"}
                onChange={(e) => props.setForm({...formRequest, password: e.target.value})}
                className={classes.normalInput}
                InputLabelProps={{
                    style: {
                        fontWeight: 300,
                        fontFamily: 'Roboto, Helvetica, sans-serif',
                        fontSize: '16px',
                    }
                }}
                helperText={ValidationHelper.isFieldInError(errors, 'Password') && ValidationHelper.getFieldErrorSummary(errors, 'Password')}
                />
        </Grid>
    )
}

const useStyles = makeStyles((theme) => ({
    normalInput: {
        marginBottom: 4,
        "& > p": {
            paddingBottom: 15,
            paddingTop: 5
        }
    }}
))